import { EMPRESAS, EMPRESA_POR_DEFECTO, CAMPOS_IMPORTE, IMPORTE_MAX, MAX_DECIMALES } from './constants';

export const SIN_VALOR = '—';

const formateador = new Intl.NumberFormat('es-ES', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: MAX_DECIMALES,
});

const esVacio = (valor) => valor === null || valor === undefined || valor === '';

export const formatearImporte = (valor) => {
  if (esVacio(valor)) return SIN_VALOR;
  const numero = Number(valor);
  return Number.isFinite(numero) ? formateador.format(numero) : SIN_VALOR;
};

// Valor inicial del input del modal: coma decimal, que es lo que teclea el usuario.
export const importeAString = (valor) => {
  if (esVacio(valor)) return '';
  const numero = Number(valor);
  return Number.isFinite(numero) ? String(numero).replace('.', ',') : '';
};

const IMPORTE_RE = /^\d+(?:[.,](\d+))?$/;

// Misma regla que el backend: >= 0, <= 99999.999 y como mucho 3 decimales.
export const validarImporte = (texto) => {
  const limpio = typeof texto === 'string' ? texto.trim() : '';
  if (!limpio) return { vacio: true };
  if (limpio.startsWith('-')) return { error: 'El importe no puede ser negativo.' };
  const match = IMPORTE_RE.exec(limpio);
  if (!match) {
    return { error: 'Introduce un número válido (coma o punto para los decimales).' };
  }
  if (match[1] && match[1].length > MAX_DECIMALES) {
    return { error: `Máximo ${MAX_DECIMALES} decimales.` };
  }
  const valor = parseFloat(limpio.replace(',', '.'));
  if (valor > IMPORTE_MAX) return { error: 'El importe máximo es 99.999,999 €.' };
  return { valor };
};

// Devuelve solo los importes que difieren del original (para el PUT) y los
// errores de validacion por campo.
export const calcularCambios = (fila, valores) => {
  const cambios = {};
  const errores = {};
  CAMPOS_IMPORTE.forEach(({ key }) => {
    const original = esVacio(fila?.[key]) ? null : Number(fila[key]);
    const resultado = validarImporte(valores?.[key]);
    if (resultado.vacio) {
      if (original !== null) errores[key] = 'Introduce un importe; no se puede dejar vacío.';
      return;
    }
    if (resultado.error) {
      errores[key] = resultado.error;
      return;
    }
    if (original === null || original !== resultado.valor) cambios[key] = resultado.valor;
  });
  return { cambios, errores };
};

export const valoresIniciales = (fila) =>
  CAMPOS_IMPORTE.reduce((acc, { key }) => ({ ...acc, [key]: importeAString(fila?.[key]) }), {});

export const mensajeErrorGuardado = (error) => {
  switch (error?.response?.status) {
    case 400:
      return 'El servidor ha rechazado los importes. Revisa el formato e inténtalo de nuevo.';
    case 403:
      return 'No tienes permiso para editar precios.';
    case 404:
      return 'Este precio ya no existe. Recarga la lista.';
    case 409:
      return 'Hay más de un precio con la misma sede y código: no se puede editar desde aquí.';
    default:
      return 'No se pudo guardar el precio. Inténtalo de nuevo.';
  }
};

// El panel no guarda una "empresa de trabajo"; lo mas cercano es el centro de la OU.
export const empresaPorDefecto = (userOU) => {
  const centro = typeof userOU?.centro === 'string' ? userOU.centro.trim().toUpperCase() : '';
  return EMPRESAS.includes(centro) ? centro : EMPRESA_POR_DEFECTO;
};
